const a = {
  code: "id",
  facebook: "id_ID",
  label: "Bahasa Indonesia",
  loadingText: "Pemuatan...",
  aliases: ["in-ID"],
  translations: {
    ar: "Bahasa Arab",
    de: "Bahasa Jerman",
    en: "Bahasa Inggris",
    es: "Bahasa Spanyol",
    fr: "Bahasa Perancis",
    he: "Bahasa Ibrani",
    hi: "Bahasa Hindi",
    id: "Bahasa Indonesia",
    it: "Bahasa Italia",
    ja: "Bahasa Jepang",
    km: "Bahasa Khmer",
    ko: "Bahasa Korea",
    lo: "Bahasa Lao",
    ms: "Bahasa Melayu",
    nl: "Bahasa Belanda",
    pt: "Bahasa Portugis",
    ru: "Bahasa Rusia",
    th: "Bahasa Thailand",
    tl: "Bahasa Filipina",
    tr: "Bahasa Turki",
    vi: "Bahasa Vietnam",
    "zh-CN": "Bahasa Cina (diseder.)",
    "zh-TW": "Bahasa Cina (trad.)"
  }
};
export {
  a as indonesian
};
